import { render, staticRenderFns } from "./planosBimestrais.vue?vue&type=template&id=bd243590"
import script from "./planosBimestrais.vue?vue&type=script&lang=js"
export * from "./planosBimestrais.vue?vue&type=script&lang=js"
import style0 from "./planosBimestrais.vue?vue&type=style&index=0&id=bd243590&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports